import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { PRICE_SCHEDULE_MODES } from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { formFields } from "./OutOfPocketMaxScheduleStepsDetailExtConfig";

const screenInfo = {
  ADD: ["Add OOP Maximum Schedule Step Detail Extension", "RCOPE003"],
  CHANGE: ["OOP Maximum Schedule Step Detail Extension Detail", "RCOPE002"],
  VIEW: ["OOP Maximum Schedule Step Detail Extension Detail", "RCOPE002"],
};

const OutOfPocketMaxScheduleStepsDetailExtForm = ({ mode }) => {
  const {
    OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT,
    OUT_OF_POCKET_MAX_SCHEDULE,
  } = ROUTE_PATHS;

  const location = useLocation();
  const { axios_helper_no_header } = useAxios();
  /*const { selectedPriceSchedules = [], 
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE_STEPS_DETAILS_EXT, 
    currentIndex: initialIndex = 0,
    opcScheduleName,
    opdStepNumber,
    opeExtensionSource,
    opeExtensionPhase
  } = location.state || {}; */
  const { state: stateVal } = location;
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  //console.log("current state in form", currentState, previousState);
  let {
    selectedDetailExtensions = [],
    previousScreen = OUT_OF_POCKET_MAX_SCHEDULE,
    currentIndex: initialIndex = 0,
    opcScheduleName,
    opdStepNumber,
    //description,
    //scheduleName,
  } = currentState;
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();

  const handleBack = () => {
    if (currentIndex < selectedDetailExtensions.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    if (isAddMode(currentMode)) {
      url = "api/opeOutPoktSchDtlExt/create";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/opeOutPoktSchDtlExt/update";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        toast.current.show({
          severity: "info",
          summary: "",
          detail: "No Change of Information",
          life: 3000,
        });
        return;
      }
    }

    const data = { ...dataForSubmission, screenNumber };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      setInitialFormData(responseData);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      }
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
    } catch (error) {
      const { responseStatus: { displayErrorFields = null, message } = {} } =
        error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex]);

  useEffect(() => {
    const fetchInitialData = async () => {
      const url = isAddMode(currentMode)
        ? `api/opeOutPoktSchDtlExt/initial-form-data/${encodeURIComponent(opcScheduleName)}?opdStepNumber=${opdStepNumber}`
        : `api/opeOutPoktSchDtlExt/${encodeURIComponent(opcScheduleName)}?opdStepNumber=${opdStepNumber}&opeExtensionSource=${selectedDetailExtensions[currentIndex].opeExtensionSource}&opeExtensionPhase=${selectedDetailExtensions[currentIndex].opeExtensionPhase}`;

      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        setInitialFormData(responseData);
      } catch (e) {}
    };

    fetchInitialData();
  }, [mode, currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default OutOfPocketMaxScheduleStepsDetailExtForm;
